import React from 'react'
import { getContentfulImageURL } from '../../../../lib/helpers'

const AboutLandingSection = ({data}) => {

    return (
        <div className='about-landing-section'>
            <div className=''>
                <div className="img-section-1">
                    <img src={getContentfulImageURL(data.v2AboutImages[0].file.url, 1400, 85)} alt="" />
                </div>
                <div className='text-section'>
                    <p>{data.v2IntroText.v2IntroText}</p>
                </div>
            </div>
            <div>
                <div className="img-section-2">
                    <img src={getContentfulImageURL(data.v2AboutImages[1].file.url, 1000, 85)} alt="" />

                </div>
            </div>

            <style jsx>{`
                .about-landing-section {
                    display: grid;
                    grid-template-columns: 2fr 1fr;
                    overflow: hidden;
                    grid-gap: 30px;
                }

                .img-section-1 {
                    height: 200px;
                    position: relative;
                }

                .img-section-1 img {
                    width: 100%;
                    border-radius: 15px;
                }
                .img-section-2 {
                    height: 100%;
                    position: relative;

                }

                .img-section-2 img {
                    height: 120%;
                    border-bottom-left-radius: 15px;
                }
                img {
                    position: absolute;
                    bottom: 0;
                }

                .text-section {
                    padding: 60px;
                }

                p {
                    font-size: 36px;
                    color: #707070;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    .about-landing-section {
                        grid-template-columns: 1fr;
                        grid-gap: 0;
                    }
                    .text-section {
                        padding: 60px 20px;
                    }

                    p {
                        font-size: 28px;
                    }
                }
            `}</style>
        </div>
    )
}

export default AboutLandingSection